import { createLogic } from "redux-logic";
import * as ActionTypes from "../../actions/actionTypes";
import * as controlPanelActions from "../../actions/controlPanelActions";

const loadPagesFailLogic = createLogic({
	type: ActionTypes.LOAD_PAGES_FAIL,
	latest: true,
	// eslint-disable-next-line no-unused-vars
	process({ getState, action }, dispatch, done) {
		let { Message } = action.errorMessage.response.data;
		dispatch(controlPanelActions.displayError(Message));
		done();
	},
});

export default [loadPagesFailLogic];
